export default "/_next/static/videos/00-002-Landingpage_1920x1080.mp4";